import CacheHelper from "@/helper/CacheHelper.js";

/**
 * @function init
 * @function getAccessToken
 * @function getIdToken
 * @function isLogin
 * @function login
 * @function logout
 * @function isTokenExpire
 * @function closeWindow
 * @function openExternalWindow
 * @function getLanguage
 * @function getLiffId
 * @function getProfile
 */
export default function LineFunction() {
    this.lineLiff = window.LineFunction;
    //#region initial
    /**
     * @param {string} liffId Line liff id
     */
    this.init = function(liffId) {
        return new Promise((resolve, reject) => {
            try {
                this.lineLiff.init(liffId, () => {
                    resolve();
                }, (err) => {
                    reject(err);
                });
            } catch (e) {
                reject(e);
            }
        });
    },
    //#endregion initial

    //#region login
    this.getAccessToken = function() {
        try {
            return this.lineLiff.getAccessToken();
        } catch (e) {
            return null;
        }
    };

    this.getIdToken = function() {
        try {
            return this.lineLiff.getIdToken();
        } catch (e) {
            return null;
        }
    };

    this.isLogin = function() {
        try {
            return this.lineLiff.isLoggedin();
        } catch (e) {
            return false;
        }
    };

    /**
     *! This function will redirect to page Line auth.
     * @param {string} callbackUrl
     */
    this.login = function(callbackUrl) {
        try {
            this.lineLiff.login(callbackUrl);
        } catch (e) {
            console.log(e);
        }
    };

    this.logout = function() {
        try {
            this.lineLiff.logout();
        } catch (e) {
            console.log(e);
        }
    }

    this.isTokenExpire = function() {
        try {
            return this.lineLiff.isTokenExpire();
        } catch (e) {
            console.log(e);
        }
    };
    //#endregion login

    //#region browser window control
    this.closeWindow = function() {
        try {
            this.lineLiff.closeWindow();
        } catch (e) {
            console.log(e);
        }
    };
    /**
     * @param {string} url
     */
    this.openExternalWindow = function(url) {
        try {
            this.lineLiff.openExternalWindow(url);
        } catch (e) {
            console.log(e);
        }
    };
    //#endregion browser window control

    //#region info
    this.getLanguage = function() {
        try {
            return this.lineLiff.getLanguage();
        } catch (e) {
            return null;
        }
    };
    this.getLiffId = function () {
        let cache = new CacheHelper('cookie');
        return cache.getCacheRaw('LineLiffId');

        // try {
        //     return this.lineLiff.getLiffId();
        // } catch (e) {
        //     return null;
        // }
    };
    this.getProfile = function() {
        try {
            return this.lineLiff.getProfile();
        } catch (e) {
            console.log(e);
        }
    };
    //#endregion info
}
